export default __webpack_public_path__ + "static/media/vegetables.160c26fe.png";